export function authorizedSelectedRecord<RecordValue, RecordId>(
  records: readonly RecordValue[],
  selectedId: RecordId | undefined,
  recordId: (record: RecordValue) => RecordId,
): RecordValue | undefined {
  return selectedId === undefined
    ? records[0]
    : records.find((record) => recordId(record) === selectedId);
}
